module.exports = __webpack_public_path__ + "img/btn-notice.f9726f6a.png";